import errors from 'Store/FormValidationStore';
import {fullErrorMessage, hasErrors} from './createError';
import type {CommonInput, ValidationError, ValidatorError} from './types';
import {customValidationString} from './utils';
import {validator as Validator} from './validator';

export function create(
  schemaString: string,
  field: string,
  value: CommonInput
): Validations {
  return new Validations(schemaString, field, value);
}

export default class Validations {
  protected validators: Array<string>;
  protected customError: string;
  protected customLabel: string;
  protected label: string;

  protected error: ValidationError;
  protected value: CommonInput;

  constructor(schemaString: string, field: string, value: CommonInput) {
    this.validators = schemaString.split('|');
    this.value = value;
    this.error = {};
    this.label = field;
    this.customError = this._customError();
    this.customLabel = this._customLabel();
  }

  private _customError(): string {
    const _error = this.validators.find(validator =>
      validator.includes('message:')
    );
    if (_error) {
      this.validators.splice(this.validators.indexOf(_error), 1);
      return customValidationString(_error?.split(':')[1]);
    }
    return '';
  }

  private _customLabel(): string {
    const _label = this.validators.find(validator =>
      validator.includes('label:')
    );
    if (_label) {
      this.validators.splice(this.validators.indexOf(_label), 1);
      return customValidationString(_label?.split(':')[1]);
    }
    return '';
  }

  private _isOptional(): boolean {
    const _optional = this.validators.find(validator =>
      validator.includes('optional')
    );
    if (_optional) {
      this.validators.splice(this.validators.indexOf(_optional), 1);
      return true;
    }
    return false;
  }

  private _validate(): Array<ValidatorError> {
    const validatorErrors: Array<ValidatorError> = [];

    if (this._isOptional() && !this.value) return [];

    this.validators.forEach(validatorEl => {
      const [validator, params] = validatorEl.split(':');

      validatorErrors.push(
        Validator(
          this.value,
          this.customLabel ? this.customLabel : this.label,
          params ? params : null
        )[validator]()
      );
    });

    return validatorErrors;
  }

  validate() {
    const validationError: ValidationError = {};

    const validatorErrors = this._validate();

    validationError[this.label] = {
      error: hasErrors(validatorErrors),
      messages: validatorErrors,
      fullErrorMessage: this.customError
        ? this.customError
        : fullErrorMessage(validatorErrors),
    };

    errors.updateErrors(this.label, validationError[this.label]);
  }
}
